<div *ngIf="alert" class="alert-container">
  <div class="close"(click)="closeAlert()">
      <i class="fa-solid fa-xmark" [ngClass]="alert.cssClass" ></i>
  </div>
  <div class="alert" [ngClass]="alert.cssClass">
      {{alert.message}}
  </div>
</div>